import { navigate } from 'gatsby';
import { useEffectOnce } from '../utils/useEffectCustom';

export default () => {
  useEffectOnce(() => navigate('/'));
  return null;
};
